import { useMemo } from 'react';

import { FlexAligner, Typography } from '@scaleaq/scaleui';
import { GensetInfo } from '@scaleaq/sitecontrol-lib';
import { useTranslation } from 'react-i18next';

import { GeneratorData } from '@/components/generators/generator/types.ts';
import { formatDurationFromSeconds, responsive } from '@/utils';

type GeneratorWidgetFooterProps = {
  generator: GensetInfo;
};

export const GeneratorStatistics = ({ generator }: GeneratorWidgetFooterProps) => {
  const { t } = useTranslation(['hybridPower']);
  const generatorData = useMemo<GeneratorData[]>(() => {
    return [
      {
        label: t('hybridPower:generator.fuelUsedToday'),
        value: Math.round(generator.fuelUsedToday).toString(),
        unit: 'L',
      },
      {
        label: t('hybridPower:generator.fuelUsedYesterday'),
        value: Math.round(generator.fuelUsedYesterday).toString(),
        unit: 'L',
      },
      {
        label: t('hybridPower:generator.totalRuntime'),
        value: formatDurationFromSeconds(generator.totalRuntime),
        unit: '',
      },
    ];
  }, [generator, t]);

  return (
    <FlexAligner
      direction='column'
      gap={responsive.spacing.xsmall}
      style={{ paddingBottom: responsive.spacing.small }}
    >
      {generatorData.map(({ label, value, unit }, index) => (
        <FlexAligner direction='row' key={index} spaceBetween alignment='center'>
          <Typography type='body_small'>{label}</Typography>
          <Typography type='body_medium'>
            {value}
            {unit.trim().length > 0 ? ` ${unit}` : ''}
          </Typography>
        </FlexAligner>
      ))}
    </FlexAligner>
  );
};
